import { KeyRound, Lock, Mail, QrCode } from 'lucide-react'

import { OrganizationAuthMethodEnum } from 'src/api/main'
import { QR_LOGIN_METHOD } from 'src/features/auth/providers'

import { ProviderLogo } from '../WorkspaceCustomProvidersPanel/ProviderLogo'

import type { BuiltInProviderDescriptor } from './types'

const COLOR_BLUE = '#2563EB'
const COLOR_AMBER = '#D97706'
const COLOR_TEAL = '#0F766E'

export const BUILT_IN_PROVIDERS: BuiltInProviderDescriptor[] = [
  {
    method: OrganizationAuthMethodEnum.PASSWORD,
    key: 'password',
    i18nKey: 'workspace.authentication.providers.password',
    protocol: 'native',
    hasCredentials: false,
    renderIcon: (size) => <Lock size={size} />
  },
  {
    method: 'email_otp',
    key: 'email_otp',
    i18nKey: 'workspace.authentication.providers.emailOtp',
    protocol: 'native',
    hasCredentials: false,
    renderIcon: (size) => <Mail size={size} />,
    iconColor: COLOR_AMBER
  },
  {
    method: QR_LOGIN_METHOD,
    key: 'qr_login',
    i18nKey: 'workspace.authentication.providers.qrLogin',
    protocol: 'native',
    hasCredentials: false,
    renderIcon: (size) => <QrCode size={size} />,
    iconColor: COLOR_BLUE
  },
  {
    method: OrganizationAuthMethodEnum.GOOGLE,
    key: 'google',
    i18nKey: 'workspace.authentication.providers.google',
    protocol: 'OIDC',
    hasCredentials: true,
    renderIcon: (size) => <ProviderLogo value="preset:google" size={size} />,
    iconColor: COLOR_BLUE
  },
  {
    method: OrganizationAuthMethodEnum.ENTRAID,
    key: 'entraid',
    i18nKey: 'workspace.authentication.providers.entraid',
    protocol: 'OIDC',
    hasCredentials: true,
    renderIcon: (size) => <ProviderLogo value="preset:microsoft" size={size} />,
    iconColor: COLOR_BLUE
  },
  {
    method: OrganizationAuthMethodEnum.APPLE,
    key: 'apple',
    i18nKey: 'workspace.authentication.providers.apple',
    protocol: 'OIDC',
    hasCredentials: true,
    renderIcon: (size) => <ProviderLogo value="preset:apple" size={size} />
  },
  {
    method: OrganizationAuthMethodEnum.PASSKEY,
    key: 'passkey',
    i18nKey: 'workspace.authentication.providers.passkey',
    protocol: 'native',
    hasCredentials: false,
    renderIcon: (size) => <KeyRound size={size} />,
    iconColor: COLOR_TEAL
  }
]
